<template>
  <section class="nim-projects" v-loading="loading">
    <el-alert v-if="error" :title="error" type="error" :closable="false" />
    <el-table :data="teams" empty-text="No NIM teams available">
      <el-table-column label="Project Title" min-width="200"><template slot-scope="{row}"><strong>{{ row.project_title || 'Untitled project' }}</strong></template></el-table-column>
      <el-table-column label="Team Member" min-width="160"><template slot-scope="{row}"><div v-for="(member,index) in row.members" :key="index" class="member">{{ member }}</div><span v-if="!row.members || !row.members.length">—</span></template></el-table-column>
      <el-table-column label="Last Updated" min-width="150"><template slot-scope="{row}">{{ row.last_updated ? new Date(row.last_updated * 1000).toLocaleString() : '—' }}</template></el-table-column>
      <el-table-column prop="progress" label="Progress" width="100" />
      <el-table-column label="Result / Award" min-width="160"><template slot-scope="{row}">{{ row.award || '—' }}</template></el-table-column>
      <el-table-column label="Operation" min-width="210"><template slot-scope="{row}">
        <div class="project-actions"><a class="el-button el-button--default el-button--small" :href="publicUrl(row)" target="_blank" rel="noopener noreferrer">View Project</a>
        <el-button size="small" type="primary" @click="openAssignments(row)">Assign Check Items</el-button></div>
        <small>{{ row.assigned_count }} assigned</small>
      </template></el-table-column>
    </el-table>
    <el-dialog title="Assign Check Items" :visible.sync="dialog" custom-class="nim-assignment-dialog" width="min(1040px, 94vw)" top="4vh" :close-on-click-modal="false" :before-close="closeDialog">
      <p>{{ selectedTeam && selectedTeam.project_title }} · Team {{ selectedTeam && selectedTeam.team_code }}</p>
      <p>Select the items students should self-check. Leaving every item unselected hides the check-item section and does not prevent submission.</p>
      <div v-loading="assignmentLoading" class="modules">
        <section v-for="module in modules" :key="module.block_id">
          <h3>{{ module.name }}</h3>
          <el-checkbox-group v-model="selectedIds" :disabled="saving">
            <el-checkbox v-for="item in module.items" :key="item.id" :label="item.id"><span v-if="item.dimension">{{ item.dimension }}: </span>{{ item.description }}</el-checkbox>
          </el-checkbox-group>
          <p v-if="!module.items.length">No configured check items.</p>
        </section>
      </div>
      <span slot="footer"><el-button :disabled="saving" @click="dialog = false">Cancel</el-button><el-button type="primary" :loading="saving" :disabled="assignmentLoading" @click="save">Save</el-button></span>
    </el-dialog>
  </section>
</template>
<script>
import { postRequest } from '../api/eae'
import { getAccountId } from '../utils/store'
export default {
  props: { projectId: { type: String, required: true } },
  data: () => ({ teams: [], loading: false, error: '', dialog: false, assignmentLoading: false, saving: false, selectedTeam: null, modules: [], selectedIds: [] }),
  mounted() { this.load() },
  methods: {
    publicUrl(team) { return 'https://www.nextideamatters.com/#/project?id=' + encodeURIComponent(team.application_id) },
    async call(name, params = {}) {
      const response = await postRequest({ function: name, account_id: getAccountId(), project_id: this.projectId, ...params })
      if (response.data.code !== 0) throw new Error(response.data.msg || 'Unable to load project data')
      return response.data.data
    },
    async load() {
      this.loading = true; this.error = ''
      try { this.teams = await this.call('getNIMTeacherProjects') }
      catch (error) { this.error = error.message }
      finally { this.loading = false }
    },
    async openAssignments(team) {
      this.selectedTeam = team; this.dialog = true; this.modules = []; this.selectedIds = []; this.assignmentLoading = true
      try { const data = await this.call('getNIMCheckAssignments', { team_code: team.team_code }); this.modules = data.modules; this.selectedIds = data.item_ids }
      catch (error) { this.$message.error(error.message); this.dialog = false }
      finally { this.assignmentLoading = false }
    },
    closeDialog(done) { if (!this.saving) done() },
    async save() {
      this.saving = true
      try {
        await this.call('saveNIMCheckAssignments', { team_code: this.selectedTeam.team_code, item_ids: this.selectedIds })
        this.selectedTeam.assigned_count = this.selectedIds.length; this.dialog = false; this.$message.success('Check items assigned')
      } catch (error) { this.$message.error(error.message) }
      finally { this.saving = false }
    }
  }
}
</script>
<style scoped>
.nim-projects { padding:20px; } .member { color:#606266; margin-top:6px; }
.modules { flex:1; min-height:0; overflow:auto; overscroll-behavior:contain; padding-right:12px; } .modules section { border-top:1px solid #ddd; padding:12px 0; }
.modules .el-checkbox { display:flex; margin:12px 0; height:auto; }
.modules >>> .el-checkbox__label { white-space:normal; line-height:1.5; }
.project-actions { display:flex; gap:8px; flex-wrap:wrap; margin-bottom:8px; }
.project-actions a { text-decoration:none; color:#606266; box-sizing:border-box; }
.project-actions .el-button { margin:0; }
.nim-projects >>> .nim-assignment-dialog { display:flex; flex-direction:column; height:88vh; max-height:880px; margin-bottom:0; }
.nim-projects >>> .nim-assignment-dialog .el-dialog__header,.nim-projects >>> .nim-assignment-dialog .el-dialog__footer { flex-shrink:0; }
.nim-projects >>> .nim-assignment-dialog .el-dialog__body { display:flex; flex-direction:column; flex:1; min-height:0; padding:12px 24px; overflow:hidden; }
.nim-projects >>> .nim-assignment-dialog .el-dialog__body > p { flex-shrink:0; margin:0 0 12px; }
.nim-projects >>> .nim-assignment-dialog .el-dialog__footer { border-top:1px solid #ebeef5; padding:16px 24px; }
</style>
